<div class="hx-action-group__container">
  <!-- Visible primary action icon buttons -->
  @for (item of visibleActions(); track item.id) {
    @if (item.customTemplate) {
      <ng-container
        *ngTemplateOutlet="
          item.customTemplate;
          context: { $implicit: item, row: row(), isOverflow: false }
        "></ng-container>
    } @else {
      <!-- Wrapper hosts the tooltip so it still shows when the button is disabled -->
      <span
        class="hx-action-group__item-wrapper"
        [hxTooltip]="item.tooltip || item.label">
        <button
          hxIconButton
          [fontIcon]="item.fontIcon || null"
          [svgIcon]="item.svgIcon || null"
          [iconSize]="item.iconSize || defaultIconSize() || '1.25rem'"
          [variant]="item.variant || defaultVariant()"
          [context]="item.destructive ? 'negative' : item.context || defaultContext()"
          [size]="size()"
          [disabled]="isItemDisabled(item)"
          [attr.aria-label]="item.ariaLabel || item.tooltip || item.label"
          class="hx-action-group__item"
          [class]="item.className || ''"
          (click)="onActionItemClick(item, $event)"></button>
      </span>
    }
  }

  <!-- Overflow Kebab Menu Button (Visible when actions overflow or space is restricted) -->
  @if (overflowActions().length > 0) {
    <button
      hxIconButton
      fontIcon="three-dots-vertical"
      [iconSize]="defaultIconSize() || '1.25rem'"
      [variant]="defaultVariant()"
      [context]="'neutral'"
      [size]="size()"
      [title]="kebabTooltip()"
      [attr.aria-label]="kebabAriaLabel()"
      [attr.aria-expanded]="isMenuOpen()"
      aria-haspopup="menu"
      [hxPopover]="kebabPanel"
      trigger="click"
      [useTriggerForHoverLifecycle]="true"
      [position]="kebabPosition()"
      [offset]="2"
      cssStyle="hx-action-group-popover-overrides"
      [backdrop]="true"
      [closeOnScroll]="true"
      (popoverOpened)="onPopoverOpened()"
      (popoverClosed)="onPopoverClosed()"
      class="hx-action-group__kebab"
      (click)="$event.stopPropagation()"></button>
  }
</div>

<!-- Kebab Menu Dropdown Popover Panel -->
<ng-template #kebabPanel>
  <div
    class="hx-action-group__menu-panel"
    role="menu">
    <div class="hx-action-group__menu-container">
      <div class="hx-action-group__menu-content">
        @for (item of overflowActions(); track item.id; let i = $index) {
          @if (item.divider && i > 0) {
            <div class="hx-action-group__divider"></div>
          }

          @if (item.customTemplate) {
            <ng-container
              *ngTemplateOutlet="
                item.customTemplate;
                context: { $implicit: item, row: row(), isOverflow: true }
              "></ng-container>
          } @else {
            <button
              type="button"
              class="hx-action-group__menu-item"
              [class.hx-action-group__menu-item--destructive]="item.destructive"
              [disabled]="isItemDisabled(item)"
              role="menuitem"
              [attr.aria-label]="item.ariaLabel || item.label"
              [attr.aria-disabled]="isItemDisabled(item)"
              [attr.tabindex]="isItemDisabled(item) ? -1 : 0"
              (click)="onOverflowItemClick(item, $event)"
              (keydown.enter)="onOverflowItemClick(item, $event)"
              (keydown.space)="onOverflowItemClick(item, $event)">
              @if (item.svgIcon || item.fontIcon) {
                <hx-icon
                  [fontIcon]="item.fontIcon || null"
                  [svgIcon]="item.svgIcon || null"
                  [inline]="true"
                  [style.font-size]="item.iconSize || '1.125rem'"
                  class="hx-action-group__menu-icon" />
              }
              <span class="hx-action-group__menu-label">{{ item.label }}</span>
            </button>
          }
        }
      </div>
    </div>
  </div>
</ng-template>
